import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sendContactSupport, clearMessages } from '../../store/slices/contactSupportSlice';
import ButtonLightBlue from '../../components/buttons/ButtonLightBlue';
import Input from '../../components/fields/Input';
import Textarea from '../../components/fields/Textarea';
import SiteHeader from '../../layout/SiteHeader'
import SiteFooter from '../../layout/SiteFooter';
import ErrorMessage from '../../components/messages/ErrorMessage';
import SuccessMessage from '../../components/messages/SuccessMessage';
import {Helmet} from "react-helmet";

const ContactSupport = () => {
  const dispatch = useDispatch();
  const { loading, error, errors, success } = useSelector((state) => state.contactSupport);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  useEffect(() => {
    dispatch(clearMessages());
  }, [dispatch]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    dispatch(clearMessages());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await dispatch(sendContactSupport(formData));

    if (sendContactSupport.fulfilled.match(result)) {
      setFormData({ name: '', email: '', subject: '', message: '' });
    }
  };

  const renderErrorMessages = () => {
    return Object.entries(errors).map(([field, messages]) => (
      <ErrorMessage key={field} message={`${messages.join(', ')}`} />
    ));
  };

  return (
    <>
      <Helmet>
          <title>Contact Support | Oreca Pro</title>
          <link rel="canonical" href={window.location.href} />
      </Helmet>
      <SiteHeader />
      <section className='guest-section relative min-h-[100vh] pb-20'>
        <div className='w-full max-w-[500px] relative mx-auto text-left px-4 pt-[120px] md:pt-[160px]'>
          <h1 className='text-3xl font-semibold my-5 text-center'>Contact Support</h1>
          <p className='mt-5 mb-7 font-normal text-center text-custom-light-grey'>
            Have a question or issue? Send us a message and we'll get back to you as soon as we can.
          </p>

          {success && <SuccessMessage message={success} />}
          {error && <ErrorMessage message={error} />}
          {renderErrorMessages()}

          <form onSubmit={handleSubmit}>
            <Input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Your name"
            />

            <Input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Your email address"
            />

            <Input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
              placeholder="Subject"
            />

            <Textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows={6}
              placeholder="How can we help?"
            />

            <ButtonLightBlue
              type="submit"
              disabled={loading}
              text={loading ? 'Sending...' : 'Send Message'}
            />
          </form>
        </div>
      </section>
      <SiteFooter />
    </>
  );
};

export default ContactSupport;
